import {
  Box,
  Button,
  Grid,
  Paper,
  TextField,
  Typography,
  Divider,
  InputAdornment,
  Modal,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
} from "@material-ui/core";
import { Info, ChevronLeft } from "@material-ui/icons";
import { makeStyles } from "@material-ui/core/styles";
import React, { useState } from "react";
const initialValuesFromDb = {
  pciSalesOrderNo: {
    value: "23540185",
    confidence: "95.01553344726562",
  },
  clientPo: {
    value: "45152629",
    confidence: "95.13410186767578",
  },
  lotNo: {
    value: "C24050",
    confidence: "95.1100082397461",
  },
  pciFgNo: {
    value: "723650",
    confidence: "95.46297454833984",
  },
  clientFgNo: {
    value: "1223158",
    confidence: "95.52490997314453",
  },
  totalShippedQnty: {
    value: "3760",
    confidence: "95.2381820678711",
  },
  totalNoOfPallets: {
    value: "3",
    confidence: "67.52731323242188",
  },
  totalNumberOfShippers: {
    value: "157",
    confidence: "67.52731323242188",
  },
  totalNetWeightOfPalletsKg: {
    value: "160",
    confidence: "67.52731323242188",
  },
  totalGrossWeightOfPalletsKg: {
    value: "205",
    confidence: "67.52731323242188",
  },
  fullPalletDimensions: {
    value: null,
    confidence: null,
  },
  partialPalletDimensions: {
    value: null,
    confidence: null,
  },
  shipToAddress: {
    value:
      "Swords Laboratories Unlimited Company Louis Pasteurweg 1 6045 GW ROERMOND NETHERIANDS",
    confidence: "92.67498016357422",
  },
  header: {
    value: "Block 7 City North Business Campus, Stamullen, Co Meath, Ireland",
    confidence: "94.70209503173828",
  },
  document_type: "PackingList",
  folder_name: "PCI",
  site_name: "Dublin",
  filename: "PCI-Dublin-PackingList-45152629-C24050.pdf",
  s3_location:
    "s3://bms-processed-files/PCI/Dublin/45152629-C24050/PCI-Dublin-PackingList-45152629-C24050.pdf",
};

const useStyles = makeStyles((theme) => ({
  formLabel: {
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-end",
    minWidth: "150px",
    paddingRight: theme.spacing(2),
    textAlign: "right",
  },
  formField: {
    marginBottom: theme.spacing(2),
  },
  requiredStar: {
    color: "red",
    marginLeft: 4,
  },
}));

function PackingList(props) {
  const [isEditable, setIsEditable] = useState(false);
  const [formValues, setFormValues] = useState(initialValuesFromDb);
  const [originalValues] = useState(initialValuesFromDb);
  const [isShowingOriginal, setIsShowingOriginal] = useState(false);
  const [lastSavedValues, setLastSavedValues] = useState(initialValuesFromDb);
  const [openModal, setOpenModal] = useState(false);
  const [modalData, setModalData] = useState({
    field: "",
    before: "",
    after: "",
    updatedBy: "user123",
    timestamp: new Date().toLocaleString(),
  });

  const classes = useStyles();
  const fields = [
    { key: "pciSalesOrderNo", label: "CMO Sales Order to Sponsor" },
    { key: "clientPo", label: "Sponsor PO Number" },
    { key: "lotNo", label: "FG Batch" },
    { key: "pciFgNo", label: "CMO FG Batch Number" },
    { key: "clientFgNo", label: "Sponsor Batch Number" },
    { key: "totalShippedQnty", label: "Number of Units of Product Shipped" },
    { key: "totalNoOfPallets", label: "Number of Pallets" },
    { key: "totalNumberOfShippers", label: "Number of Cartons" },
    { key: "totalNetWeightOfPalletsKg", label: "Net Weight" },
    { key: "totalGrossWeightOfPalletsKg", label: "Gross Weight" },
    { key: "fullPalletDimensions", label: "Full Pallet Dimensions" },
    { key: "partialPalletDimensions", label: "Partial Pallet Dimensions" },
    { key: "shipToAddress", label: "Ship To" },
    { key: "header", label: "Pickup Location" },
  ];

  const getLevelColor = (level) => {
    const num = typeof level === "string" ? parseFloat(level) : level;
    if (num < 80) return "red";
    if (num <= 90) return "orange";
    return "green";
  };

  const handleInputChange = (key, value) => {
    let isValid = true;

    // Inline filtering logic
    switch (key) {
      case "pciSalesOrderNo":
      case "clientPo":
      case "pciFgNo":
      case "clientFgNo":
      case "totalShippedQnty":
      case "totalNoOfPallets":
      case "totalNumberOfShippers":
      case "fullPalletDimensions":
      case "partialPalletDimensions":
      case "totalNoOfPallets":
        isValid = /^[0-9]*$/.test(value);
        break;
      case "lotNo":
      case "shipToAddress":
      case "header":
        isValid = /^[a-zA-Z0-9]*$/.test(value);
        break;
        case "totalNetWeightOfPalletsKg":
        case "totalGrossWeightOfPalletsKg":
          isValid = /^\d*\.?\d*$/.test(value);
          break;
      
      

      default:
        isValid = true;
    }

    if (!isValid) return;
    
    setFormValues((prev) => ({
      ...prev,
      [key]: {
        ...prev[key],
        value: value,
      },
    }));
  };

  const isFieldChanged = (key) => {
    return formValues[key]?.value !== originalValues[key]?.value;
  };
  return (
    <>
      <Grid container direction="column" spacing={2}>
        <Grid item container alignItems="center" spacing={2}>
          <Grid item>
            <Button
              startIcon={<ChevronLeft fontSize="small" />}
              style={{
                fontWeight: "bold",
                textTransform: "none",
                marginLeft: "0px",
              }}
            >
              Back
            </Button>
          </Grid>
          <Grid item>
            <Typography variant="h6">Digitized Packing List</Typography>
          </Grid>
        </Grid>

        <Grid item>
          <Divider
            style={{
              margin: "0px 0px 0px 0px",
              backgroundColor: "#707070",
              height: 1,
              zIndex: 4,
            }}
          />
        </Grid>

        <Grid item container alignItems="center">
          <Grid item>
            <Typography
              variant="h6"
              style={{
                whiteSpace: "normal",
                wordBreak: "break-word",
              }}
            >
              Packing List Data
            </Typography>
          </Grid>
          <Grid item style={{ width: "78px" }} />{" "}
          <Grid item>
            <Box display="flex" gap={5} style={{ minWidth: "397px" }}>
              <Button
                color="primary"
                variant="outlined"
                onClick={() => {
                  if (isEditable) {
                    setLastSavedValues(formValues);
                  }
                  setIsEditable((prev) => !prev);
                }}
                style={{ minWidth: 15, textAlign: "center"}}
              >
                {isEditable ? "Save Changes" : "Edit"}
              </Button>
              <Grid item style={{ width: "10px" }} />
              <Button
                color="secondary"
                variant="outlined"
                onClick={() => {
                  if (!isShowingOriginal) {
                    setFormValues(originalValues);
                  } else {
                    setFormValues(lastSavedValues);
                  }
                  setIsShowingOriginal(!isShowingOriginal);
                  setIsEditable(false);
                }}
                style={{ minWidth: 20, textAlign: "center", size: "20px" }}
              >
                {isShowingOriginal
                  ? "Show Edited Version"
                  : "Show Unedited Version"}
              </Button>
            </Box>
          </Grid>
          <Grid item style={{ width: "30px" }} />
          <Grid item>
            <Typography variant="h6">PDF Preview</Typography>
          </Grid>
        </Grid>

        <Grid item container spacing={2}>
          <Grid item xs={12} md={6}>
            <Paper
              elevation={2}
              style={{
                height: "calc(100vh - 200px)",
                padding: 16,
                overflowY: "auto",
              }}
            >
              {fields.map((field) => (
                <Grid
                  container
                  key={field.key}
                  alignItems="center"
                  spacing={2}
                  className={classes.formField}
                >
                  <Grid item xs={4}>
                    <Typography style={{ paddingRight: 16, fontWeight: 500 }}>
                      {field.label}
                      {![
                        "CMO Sales Order to Sponsor",
                        "Sponsor PO Number",
                        "FG Batch",
                        "CMO FG Batch Number",
                        "Sponsor Batch Number",
                      ].includes(field.label) && (
                        <span className={classes.requiredStar}>*</span>
                      )}
                    </Typography>
                  </Grid>
                  <Grid item xs={8}>
                    <TextField
                      variant="outlined"
                      fullWidth
                      size="small"
                      value={formValues[field.key]?.value || ""}
                      onChange={(e) =>
                        handleInputChange(field.key, e.target.value)
                      }
                      onBlur={(e) => {
                        const { value } = e.target;
                        // Trim leading and trailing spaces for string values
                        if (typeof value === "string" && value.trim() !== value) {
                          handleInputChange(field.key, value.trim());
                        }
                      }}
                      placeholder={`Enter ${field.label}`}
                      InputProps={{
                        readOnly: !isEditable,
                        endAdornment: (
                          <InputAdornment position="end">
                            <Box display="flex" alignItems="center" pl={1}>
                              <Box
                                style={{
                                  width: 1,
                                  height: 39,
                                  backgroundColor: "#ccc",
                                  marginRight: 3,
                                }}
                              />
                              {!isEditable ? (
                                 isFieldChanged(field.key) ? (
                                  <Box
                                    onClick={() => {
                                      setModalData({
                                        field: field.label,
                                        before: originalValues[field.key]?.value,
                                        after: lastSavedValues[field.key]?.value,
                                        updatedBy: "user123",
                                        timestamp: new Date().toLocaleString(),
                                      });
                                      setOpenModal(true);
                                    }}
                                    style={{
                                      backgroundColor: "#7777",
                                      color: "white",
                                      borderRadius: 4,
                                      padding: "2px 8px",
                                      fontSize: "0.75rem",
                                      fontWeight: 600,
                                      minWidth: 24,
                                      textAlign: "center",
                                      cursor: "pointer",
                                    }}
                                  >
                                    <Info fontSize="small" />
                                  </Box>
                                ) : (
                                  <Box
                                    style={{
                                      backgroundColor: getLevelColor(
                                        formValues[field.key]?.confidence
                                      ),
                                      color: "white",
                                      borderRadius: 4,
                                      padding: "2px 8px",
                                      fontSize: "0.75rem",
                                      fontWeight: 600,
                                      minWidth: 24,
                                      textAlign: "center",
                                    }}
                                  >
                                    {Math.round(
                                      formValues[field.key]?.confidence
                                    )}
                                  </Box>
                                )
                              ) : (
                                <Box
                                  style={{
                                    backgroundColor: getLevelColor(
                                      formValues[field.key]?.confidence
                                    ),
                                    color: "white",
                                    borderRadius: 4,
                                    padding: "2px 8px",
                                    fontSize: "0.75rem",
                                    fontWeight: 600,
                                    minWidth: 24,
                                    textAlign: "center",
                                  }}
                                >
                                  {Math.round(
                                    formValues[field.key]?.confidence
                                  )}
                                </Box>
                              )}
                            </Box>
                          </InputAdornment>
                        ),
                      }}
                    />
                  </Grid>
                </Grid>
              ))}

              <Box display="flex" alignItems="center" gap={2} mb={2} mt={3}>
                <Typography variant="body2" color="textSecondary">
                  Confidence Levels Legend:{" "}
                </Typography>
                <Grid item style={{ width: "28px" }} />
                <Box
                  style={{
                    backgroundColor: "green",
                    color: "white",
                    borderRadius: 4,
                    padding: "4px 12px",
                    fontSize: "0.75rem",
                    fontWeight: 600,
                    textAlign: "center",
                    minWidth: 30,
                  }}
                >
                  &gt; 90
                </Box>
                <Box
                  style={{
                    backgroundColor: "orange",
                    color: "white",
                    borderRadius: 4,
                    padding: "4px 12px",
                    fontSize: "0.75rem",
                    fontWeight: 600,
                    textAlign: "center",
                    minWidth: 50,
                    marginLeft: 16,
                  }}
                >
                  80 to 90
                </Box>
                <Box
                  style={{
                    backgroundColor: "red",
                    color: "white",
                    borderRadius: 4,
                    padding: "4px 12px",
                    fontSize: "0.75rem",
                    fontWeight: 600,
                    textAlign: "center",
                    minWidth: 30,
                    marginLeft: 16,
                  }}
                >
                  &lt; 80
                </Box>
              </Box>
            </Paper>
          </Grid>

          <Grid item xs={12} md={6}>
            <Paper
              elevation={2}
              style={{
                height: "calc(100vh - 200px)",
                padding: 16,
                overflowY: "auto",
              }}
            >
              <Box
                style={{
                  height: 500,
                  backgroundColor: "#f5f5f5",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  border: "1px dashed #ccc",
                }}
              >
                <iframe
                  src=""
                  title="PDF Preview"
                  width="100%"
                  height="100%"
                  style={{ border: "none" }}
                />
              </Box>
            </Paper>
          </Grid>
        </Grid>
      </Grid>

      <Modal open={openModal} onClose={() => setOpenModal(false)}>
        <Box
          style={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            backgroundColor: "#fff",
            padding: 24,
            boxShadow: 24,
            borderRadius: 8,
            minWidth: 600,
          }}
        >
          <Typography variant="h6" gutterBottom>
            {modalData.field} - Field Data History
          </Typography>

          <Table>
            <TableHead
              style={{ border: "1px solid grey", backgroundColor: "#7777" }}
            >
              <TableRow
                style={{ border: "1px solid grey", backgroundColor: "#7777" }}
              >
                <TableCell>
                  <b>Timestamp</b>
                </TableCell>
                <TableCell>
                  <b>Before Value</b>
                </TableCell>
                <TableCell>
                  <b>After Value</b>
                </TableCell>
                <TableCell>
                  <b>Updated By</b>
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody style={{ border: "1px solid grey" }}>
              <TableRow>
                <TableCell>{modalData.timestamp}</TableCell>
                <TableCell>{modalData.before}</TableCell>
                <TableCell>{modalData.after}</TableCell>
                <TableCell>{modalData.updatedBy}</TableCell>
              </TableRow>
            </TableBody>
          </Table>

          <Box display="flex" justifyContent="center" mt={3}>
            <Button
              variant="contained"
              color="primary"
              onClick={() => setOpenModal(false)}
            >
              OK
            </Button>
          </Box>
        </Box>
      </Modal>
    </>
  );
}

export default PackingList;
